import React, { useRef, useState } from "react";

import { ReportCellLayoutManagerDropdown } from "./ReportCellLayoutManagerDropdown";
import styles from "./ReportCellLayoutManagerSelect.module.scss";
import { LayoutIcon } from "./assets";
import { useClickAway } from "react-use";
export const ReportCellLayoutManagerSelect: React.FC<{
  pageId: string;
  cellId: string;
}> = ({ pageId, cellId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  const anchor = useRef(null);

  useClickAway(anchor, (e) => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  return (
    <div ref={anchor} style={{ position: "relative" }}>
      <div onClick={handleClick} className={styles.button}>
        <LayoutIcon />
      </div>
      {isOpen && (
        <ReportCellLayoutManagerDropdown
          onClose={handleClose}
          pageId={pageId}
          cellId={cellId}
        />
      )}
    </div>
  );
};
